import { Container, SimpleGrid } from '@chakra-ui/react'
import CardLeaft from 'components/CardLeaf'
import Layout from 'components/Layout/Default'
import LightGalery from 'components/LightGalery'
import Modal from 'components/Modal'
import { useRef } from 'react'
import { getList } from 'services/photos/action'
import { PhotosType } from 'services/photos/types'

export const getStaticProps = async () => {
  const res = await getList()

  return {
    props: {
      data: res,
    },
    revalidate: 10,
  }
}

const Fotos = ({ data }: { data: PhotosType }) => {
  const ref = useRef(null)

  const list = data?.acf?.images
  console.log(list)

  return (
    <Layout
      category="Fotos"
      title="Fotos de Gramados, Gramas para Jardim"
      description="Confira imagens de alguns de nossos trabalhos. Dentre eles destacamos jardins residenciais feitos por Eduardo Rusew especialista em paisagismo e jardinagem."
      keywords="fotos de grama, fotos de gramas, fotos grama esmeralda, fotos grama esmeralda premium, fotos grama batatais, fotos grama batatais plus, fotos grama são carlos, fotos grama são carlos plus, fotos grama bermuda, fotos grama bermuda celebration, fotos grama celebration, fotos grama tifton, fotos japonesa, fotos grama coreana, fotos grama inglesa, fotos grama santo agostinho"
      categorySize="1.6rem"
    >
      <section>
        <Container maxW="7xl">
          <SimpleGrid columns={[1, 1, 2, null, 3]} spacing={15} ref={ref}>
            {list?.map((item, index) => (
              <Modal key={index} title={item?.title} image={item.image} />
            ))}
          </SimpleGrid>
        </Container>
      </section>
    </Layout>
  )
}

export default Fotos
